import { IndexPage } from '../pages/index-page';
import GarageIndexPage from '../pages/garage-index';
import AdminManagement from '../pages/admin-management';
import AdminRoute from './AdminRoute';

export default function HostHome() {
  const host = window.location.hostname;
  if (host === 'garage.mycarapp.co.ke') return <GarageIndexPage />;
  if (host === 'admin.mycarapp.co.ke') return <AdminRoute><AdminManagement /></AdminRoute>;
  return <IndexPage />;
}